<template>
    <v-app>
        <dashboard-core-app-bar v-model="expandOnHover" />

        <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" />

        <dashboard-core-view />

        <dashboard-core-footer />

        <!-- <dashboard-core-settings v-model="expandOnHover" /> -->
    </v-app>
</template>

<script>
    export default {
        name: 'DashboardIndex',

        /* >>> *************************************************************** / /* Components */
        components: {

            DashboardCoreAppBar: () => import('./components/core/AppBar'),
            DashboardCoreDrawer: () => import('@/components/core/Drawer'), // global
            DashboardCoreView: () => import('@/components/core/View'), // global
            // DashboardCoreSettings: () => import('@/components/core/Settings'), // global
            DashboardCoreFooter: () => import('@/components/core/Footer') // global

        }, // eof components{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data: () => ({

            expandOnHover: false

        }) // eof data()
        /* <<< ****************************************************************/
    }
</script>
